/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Features_Desc8Inputs */

const en_svc_retainer_features_desc8 = /** @type {(inputs: Svc_Retainer_Features_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoped monthly capacity for the tweaks that never make a sprint.`)
};

const ar_svc_retainer_features_desc8 = /** @type {(inputs: Svc_Retainer_Features_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سعة شهرية محددة للتعديلات التي لا تصل إلى سبرينت أبدا.`)
};

const bn_svc_retainer_features_desc8 = /** @type {(inputs: Svc_Retainer_Features_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যেসব বদল কখনো স্প্রিন্টে ওঠে না তার জন্য মাসিক সীমিত ক্ষমতা।`)
};

const de_svc_retainer_features_desc8 = /** @type {(inputs: Svc_Retainer_Features_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festgelegte monatliche Kapazität für die Anpassungen, die nie einen Sprint schaffen.`)
};

const es_svc_retainer_features_desc8 = /** @type {(inputs: Svc_Retainer_Features_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidad mensual acotada para los ajustes que nunca llegan a un sprint.`)
};

const fr_svc_retainer_features_desc8 = /** @type {(inputs: Svc_Retainer_Features_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacité mensuelle cadrée pour les ajustements qui ne font jamais un sprint.`)
};

const pt_svc_retainer_features_desc8 = /** @type {(inputs: Svc_Retainer_Features_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidade mensal delimitada para os ajustes que nunca chegam a um sprint.`)
};

const zh_svc_retainer_features_desc8 = /** @type {(inputs: Svc_Retainer_Features_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月固定额度，做那些永远排不上迭代的小调整。`)
};

const tr_svc_retainer_features_desc8 = /** @type {(inputs: Svc_Retainer_Features_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprinte hiç sığmayan rötuşlara ayrılmış aylık kapasite.`)
};

const ru_svc_retainer_features_desc8 = /** @type {(inputs: Svc_Retainer_Features_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очерченная месячная ёмкость под правки, которые никогда не попадают в спринт.`)
};

const pl_svc_retainer_features_desc8 = /** @type {(inputs: Svc_Retainer_Features_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ograniczona miesięczna pojemność na poprawki, które nigdy nie mieszczą się w sprincie.`)
};

/**
* | output |
* | --- |
* | "Scoped monthly capacity for the tweaks that never make a sprint." |
*
* @param {Svc_Retainer_Features_Desc8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_features_desc8 = /** @type {((inputs?: Svc_Retainer_Features_Desc8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Features_Desc8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_features_desc8(inputs)
	if (locale === "bn") return bn_svc_retainer_features_desc8(inputs)
	if (locale === "de") return de_svc_retainer_features_desc8(inputs)
	if (locale === "es") return es_svc_retainer_features_desc8(inputs)
	if (locale === "fr") return fr_svc_retainer_features_desc8(inputs)
	if (locale === "pt") return pt_svc_retainer_features_desc8(inputs)
	if (locale === "zh") return zh_svc_retainer_features_desc8(inputs)
	if (locale === "tr") return tr_svc_retainer_features_desc8(inputs)
	if (locale === "ru") return ru_svc_retainer_features_desc8(inputs)
	if (locale === "pl") return pl_svc_retainer_features_desc8(inputs)
	return en_svc_retainer_features_desc8(inputs)
});
export { svc_retainer_features_desc8 as "svc_retainer_FEATURES_desc" }